module.exports = __webpack_public_path__ + "img/logo-text.1bd2d735.png";